/**
 * Feel free to use this file if you need javascript that is only
 * supposed to load on the front-end with your block.
 *
 * For instance, this can be handy if you want to add some interaction or slider
 * functionality not appropriate for the editor experience.
 */
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use( [ Navigation, Pagination ] );

/**
 * Initialises the swiper library to be used on the frontend
 */
const categorySliders = document.querySelectorAll( '.shop-categories-list.swiper' );

categorySliders.forEach( sliderInstance => {
	const sliderParent = sliderInstance.closest( '.wp-block-qala-blocks-shop-categories' );
	let sliderLoop = sliderInstance.classList.contains( 'has-loop' ) ? true : false;
	const numberColumns = parseInt( sliderInstance.getAttribute( 'data-columns' ) );
	const slides = sliderInstance.querySelectorAll( '.swiper-slide' );
	const numberSlides = slides.length;

	// if number of slides is equal or less than columns, disable loop mode to avoid console warning.
	if ( numberSlides <= numberColumns ) {
		sliderLoop = false;
	}

	new Swiper( sliderInstance, {
		createElements: true,
		loop: sliderLoop,
		slidesPerView: 'auto',
		watchSlidesProgress: true,
		threshold: 1,
		navigation: {
			nextEl: sliderParent.querySelector( '.next-arrow' ),
			prevEl: sliderParent.querySelector( '.prev-arrow' ),
		},
	} );
} );

document.querySelectorAll( '.shop-category-item' ).forEach( categoryItem => {
	categoryItem.addEventListener( 'click', e => {
		if ( e.target.tagName !== 'A' ) {
			categoryItem.querySelector( 'a' ).click();
		}
	} );
} );
